module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_3.1c7b39f0.png";